import React from 'react';
import { Field } from 'react-final-form';
import { useFieldValue } from 'Shared/utils/hooks';
import FormSelect from 'Shared/components/FormComponents/FormSelect';
import { useSelector } from 'react-redux';

import {
  recurrenceIntervalOptions,
  defaultMonthCountInDays,
  defaultWeekCountInDays,
  maxTimeWithoutPromptInDays,
} from '../../../constants';
import Input from './NumberInput/NumberInput';
import { WpIcon } from 'Wpds/components/icon';

const customStyles = {
  valueContainer: base => ({
    ...base,
    maxHeight: 36,
    minHeight: 36,
  }),
  control: base => ({
    ...base,
    border: 0,
    borderBottom: '1px solid #0238BB',
    borderRadius: 0,
    minHeight: 36,
    maxHeigth: 36,
    width: 100,
    boxShadow: 'none',
    fontSize: '20px',
  }),
};

export default function FormFields() {
  const workspacesCount = useFieldValue('workspaces').length;
  const recurrenceInterval = useFieldValue('managerAssistantSettings.recurrenceInterval');
  const recurrenceAmount = useFieldValue('managerAssistantSettings.recurrenceAmount');

  const recurrenceAmountInDays =
    recurrenceInterval === 'week'
      ? recurrenceAmount * defaultWeekCountInDays
      : recurrenceAmount * defaultMonthCountInDays;

  const teammatePerWeek = Math.min(
    workspacesCount,
    Math.ceil(workspacesCount * (recurrenceAmountInDays / maxTimeWithoutPromptInDays))
  );
  const isManager = useSelector(state => state.onboardingState?.profile?.role === 'manager');

  return (
    <>
      {isManager && (
        <>
          <p className="font-weight-bold mt-5">How often do you want to be reminded?</p>
          <div className="d-flex align-items-center">
            <p className="onboarding-mas-label my-0 mr-2">Remind me every</p>
            <Field
              name="managerAssistantSettings.recurrenceAmount"
              className="onboarding-mas-input mr-2"
              component={Input}
              min={1}
              max={recurrenceInterval === 'month' ? defaultMonthCountInDays : defaultWeekCountInDays}
            />
            <Field
              name="managerAssistantSettings.recurrenceInterval"
              className="onboarding-mas-select"
              options={recurrenceIntervalOptions}
              component={FormSelect}
              components={{
                IndicatorSeparator: null,
                DropdownIndicator: () => (
                  <span className="onboarding-mas-select-dropdownIndicator">
                    <WpIcon name="chevron-down" />
                  </span>
                ),
              }}
              customStyles={customStyles}
            />
          </div>
        </>
      )}
      <div className="d-flex flex-column mt-5 rounded border onboarding-mas-info-card">
        <p className="text-muted m-0">
          You’ll be prompted to give feedback to {teammatePerWeek} teammate{teammatePerWeek === 1 ? '' : 's'} every{' '}
          {recurrenceAmount} {recurrenceInterval}
          {recurrenceAmount === 1 ? '' : 's'}.{' '}
        </p>
        {/* <div>
          <button className="btn text-primary p-0" type="button" >
            <WpIcon name="chevron-right" className="mr-2" />
            Advanced Settings
          </button>
        </div> */}
      </div>
    </>
  );
}
